import { IN_APP_HELP_COMPONENT, CALLING_COMPONENT, MINI_TRIAL_GUIDE_COMPONENT } from 'navigation-components/config';
import { isValidWidgetMessageAction } from '../../in-app-help/constants/widgetMessageActions';
import { isValidRemoteMessageAction } from '../../calling-remote/constants/remoteMessageActions';
export const validActions = {
  [IN_APP_HELP_COMPONENT]: isValidWidgetMessageAction,
  [CALLING_COMPONENT]: isValidRemoteMessageAction,
  [MINI_TRIAL_GUIDE_COMPONENT]: isValidRemoteMessageAction
};